import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const PaletteIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 2C6.49 2 2 5.86 2 10.9C2 15.4 5.73 18 9.1 18H10c1 0 1.8.8 1.8 1.8c0 1.2 1 2.2 2.2 2.2c4 0 8-3.2 8-8.1C22 7.02 17.52 2 12 2z" />
    <circle cx="7.6" cy="9.1" r="1.2" />
    <circle cx="10.4" cy="6.8" r="1.1" />
    <circle cx="13.8" cy="6.6" r="1.1" />
    <circle cx="16.6" cy="9" r="1.1" />
  </SvgIcon>
);

export default PaletteIcon;
